import { render, staticRenderFns } from "./SetExtraStore.vue?vue&type=template&id=903984b2"
import script from "./SetExtraStore.vue?vue&type=script&lang=js"
export * from "./SetExtraStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports